export const KEY_LOCALE = 'locale';
export const KEY_CURRENCY = 'currency';
export const KEY_H5SERVICE_APIKEY = 'apikey_h5service';
export const KEY_BFFSERVICE_APIKEY = 'apikey_bffservice';
